<template>
  <div class="activate">
    <div class="tab">
      <van-tabs v-model="tabName" @click="handleTab">
        <van-tab title="订单激活">
          <div class="card-info">
            <van-cell-group>
              <van-field
                v-model="listQuery.phone"
                label="手机号"
                placeholder="输入车主手机号"
              />
              <van-field
                v-model="activityName"
                readonly
                clickable
                label="卡名称"
                placeholder="请选择"
                @click="handleActivity"
              />
              <van-field
                readonly
                clickable
                name="calendar"
                :value="invalidDate"
                label="失效日期"
                placeholder="请选择日期"
                @click="showCalendar = true"
              />
            </van-cell-group>
          </div>
          <div class="activate-btn">
            <van-button type="primary" @click="handleActive"> 激活 </van-button>
          </div>
        </van-tab>
        <van-tab title="会员套餐开通">
          <div class="card-info">
            <van-cell-group>
              <van-field
                v-model="listQuery.phone"
                label="手机号"
                placeholder="输入车主手机号"
              />
              <van-field
                v-model="activityName"
                readonly
                clickable
                label="套餐名称"
                placeholder="请选择"
                @click="handleCombo"
              />
              <van-field
                readonly
                clickable
                name="calendar"
                :value="invalidDate"
                label="失效日期"
                placeholder="根据套餐自动填充"
              />
            </van-cell-group>
          </div>
          <div class="activate-btn">
            <van-button type="primary" @click="handleDredge"> 开通 </van-button>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 卡券弹框 -->
    <van-popup v-model="activityPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="activityColumns"
        @confirm="handleSelectActivity"
        @cancel="activityPicker = false"
      />
    </van-popup>
    <!-- 日期选择 -->
    <van-calendar
      color="#07c160"
      v-model="showCalendar"
      @confirm="handleInvalidDate"
    />
  </div>
</template>
<script>
import { Dialog } from "vant";
import { orderList, orderActive } from "@/api/order";
import { membersPackageList, dredgeCombo } from "@/api/combo";
export default {
  data() {
    return {
      tabName: "订单激活",
      activityPicker: false,
      activityColumns: [],
      activityList: [],
      comboList: [],
      activityName: "",
      showCalendar: false,
      invalidDate: "",
      orderNo: "",
      listQuery: {
        page: 1,
        size: 10,
        phone: "",
        status: 0,
        promotionId: ""
      }
    };
  },
  methods: {
    // 表单初始化
    initData() {
      this.activityName = "";
      this.listQuery.phone = "";
      this.invalidDate = "";
    },
    // 套餐列表
    handleMembersPackageList() {
      membersPackageList().then(res => {
        // console.log("套餐列表 :>> ", res);
        this.comboList = res;
        this.activityColumns = [];
        res.forEach(val => {
          this.activityColumns.push(val.name);
        });
        if (this.activityColumns.length === 0) {
          this.$toast("暂无套餐记录,请前往添加");
          return false;
        }
        this.activityPicker = true;
      });
    },
    // 套餐选择
    handleCombo() {
      this.handleMembersPackageList();
    },
    // 根据车主手机号获取活动
    handleActivity() {
      if (this.listQuery.phone.trim() === "") {
        this.$toast("请输入车主手机号");
        return false;
      }
      this.activityColumns = [];
      orderList(this.listQuery).then(res => {
        // console.log("订单列表:", res);
        this.activityList = res;
        res.forEach(val => {
          this.activityColumns.push(val.promotionName);
        });
        if (this.activityColumns.length === 0) {
          this.$toast("该车主无未激活卡");
          return false;
        }
        this.activityPicker = true;
      });
    },
    // 选择活动
    handleSelectActivity(val) {
      // console.log("选择活动 :>> ", val);
      this.activityName = val;
      if (this.tabName === 1) {
        let currentDate = new Date();
        this.comboList.forEach(val => {
          if (val.name === this.activityName) {
            currentDate.setDate(currentDate.getDate() + val.termOfValidity);
          }
        });
        this.invalidDate = this.formatDate(currentDate);
      } else {
        this.handleDefaultDate();
      }
      this.activityPicker = false;
    },
    // 失效日期选择
    handleInvalidDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      const year = date.getFullYear();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      this.invalidDate = year + "-" + month + "-" + day;
      this.showCalendar = false;
    },
    // 激活
    handleActive() {
      const data = {
        orderNo: "",
        expiresDate: this.invalidDate
      };
      this.activityList.forEach(val => {
        if (val.promotionName === this.activityName) {
          data.orderNo = val.orderNo;
        }
      });
      if (data.orderNo.trim() === "") {
        this.$toast("请选择需要激活的卡");
        return false;
      }
      if (data.expiresDate.trim() === "") {
        this.$toast("请选择失效日期");
        return false;
      }
      orderActive(data).then(res => {
        this.initData();
        // console.log("激活:", res);
        if (res.code === 0) {
          Dialog({ message: "已激活" });
        }
      });
    },
    // 开通
    handleDredge() {
      if (this.listQuery.phone.trim() === "") {
        this.$toast("请输入车主手机号");
        return false;
      }
      let query = {
        id: "",
        phone: this.listQuery.phone,
        validTime: this.invalidDate
      };
      this.comboList.forEach(val => {
        if (val.name === this.activityName) {
          query.id = val.id;
        }
      });
      dredgeCombo(query).then(res => {
        this.initData();
        if (res.code === 0) {
          Dialog({ message: "已开通" });
        }
      });
    },
    // 标签栏
    handleTab() {
      this.initData();
    },
    // 日期格式化
    formatDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      let invalidDate = year + "-" + month + "-" + day;
      return invalidDate;
    },
    // 默认失效日期
    handleDefaultDate() {
      let DefaultDate = new Date();
      DefaultDate.setFullYear(DefaultDate.getFullYear() + 1);
      DefaultDate.setDate(DefaultDate.getDate() - 1);
      this.invalidDate = this.formatDate(DefaultDate);
    }
  }
};
</script>
<style lang="scss" scoped>
.activate {
  .tab {
    .card-info {
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.activate {
  .tab {
    .van-tabs--line .van-tabs__wrap {
      margin-bottom: 20px;
    }
  }
}
</style>
